import { Box, Grid } from "@mui/material";
import { searchSelectedTab, setInnCode } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import Tabs from "components/common/Tabs";
import Typography from "components/common/Typography";
import InncodeDropDown from "components/common/dropdowns/InncodeDropDown";
import SearchAppBar from "components/common/searchBar";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { planTypes } from "utils/Types";
import { tabDetails } from "../functionalArea/TabsConfig";

function LibraryHallSearch() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const searchText = searchParams.get("q") as string;
  const cardId = searchParams.get("cardid") as string;
  const selectedTab = useAppSelector((state) => state.app.searchSelectedTab);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const backURL = "/library";
  const { isMobileScreen } = useContext(ThemeContext);
  const isAdmin = useAppSelector((state) => state.app.isAdmin);

  useEffect(() => {
    dispatch(searchSelectedTab(cardId || location.state?.cardId ? 1 : 0));
  }, [cardId]);

  const handleOnChange = (value: string) => {
    dispatch(setInnCode(value));
    localStorage.setItem("innCode", value);
  };

  const getInputDetails = (inputText: string) => {
    if (inputText.length > 2 || !inputText) navigate(`/library/search?q=${inputText}`, { state: { backURL: backURL } });
  };

  const handleTabSelection = (x: number) => {
    dispatch(searchSelectedTab(x));
  };

  return (
    <>
      <Grid sx={{ backgroundColor: tokens.Background.General.Secondary }}>
        <Grid display={"flex"} alignItems="center" justifyContent={"center"} sx={{ textAlign: "center", gap: "8px" }}>
          <Typography variant="body2" color={tokens.Text.General.Secondary}>
            Exploring plans for
          </Typography>
          <InncodeDropDown
            backgroundColor={tokens.Background.General.Color}
            width={isMobileScreen ? "170px" : "284px"}
            height="24px"
            color={tokens.Text.General.Color}
            isAdmin={isAdmin}
            value={innCode}
            onChange={handleOnChange}
          />
        </Grid>
        <Grid
          sx={{ marginTop: "38px" }}
          display="flex"
          flexDirection={isMobileScreen ? "column" : "row"}
          justifyContent="flex-start"
          alignItems={"center"}
          gap={isMobileScreen ? "16px" : "50px"}
          width={isMobileScreen ? "100%" : "50%"}
        >
          <Typography color={tokens.Text.General.PrimaryHeadline} showBold variant={"h5"}>
            Search in Library
          </Typography>
          {isMobileScreen ? (
            <>
              <Grid
                marginBottom={"8px"}
                xs={12}
                textAlign={"center"}
                display={"flex"}
                justifyContent={"center"}
                flexWrap={"wrap"}
                gap="5px"
              >
                <Typography variant={"body1"}>Showing search results</Typography>
                {searchText && (
                  <>
                    <Typography variant={"body1"}>for</Typography>
                    <Typography variant={"body1"} showBold>
                      "{searchText}"
                    </Typography>
                  </>
                )}
              </Grid>
              <SearchAppBar
                getInputDetails={getInputDetails}
                value={searchText}
                planType={planTypes.AllPlans}
                divider
              ></SearchAppBar>
            </>
          ) : (
            <SearchAppBar
              getInputDetails={getInputDetails}
              value={searchText}
              planType={planTypes.AllPlans}
              divider
            ></SearchAppBar>
          )}
        </Grid>
        {!isMobileScreen && (
          <Box marginTop={"16px"} display="flex" flexDirection={"row"} gap="5px">
            <Typography variant={"body1"}>Showing search results</Typography>
            {searchText && (
              <>
                <Typography variant={"body1"}>for</Typography>
                <Typography variant={"body1"} showBold>
                  "{searchText}"
                </Typography>
              </>
            )}
          </Box>
        )}
        <Grid marginTop={3} item md={12}>
          <Tabs
            alignItems="flex-start"
            tabDetails={tabDetails}
            defaultTab={selectedTab || 0}
            selectedTab={handleTabSelection}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default LibraryHallSearch;
